module.exports = __webpack_public_path__ + "media/images/front/icon_note-68ed3e9e6527618fc6b20e848ce79be1.png";